// removed by extract-text-webpack-plugin
module.exports = {"other-product-popup":"other-product-popup","title-other-product-popup":"title-other-product-popup","wrap-other-product":"wrap-other-product","product":"product","price":"price"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/product/popup-view-detail/other-product/style.scss
// module id = ./components/partials/product/popup-view-detail/other-product/style.scss
// module chunks = 0